import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper'
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { NgxMaskModule, IConfig } from 'ngx-mask';

/** Custom */
import { RatingComponent } from './rating/rating.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { RegistroClienteComponent } from './cliente/registro/registro-cliente.component';
import { EditarDadosClienteComponent } from './cliente/editar-dados/editar-dados-cliente.component';
import { AdicionaNegociacaoComponent } from './adiciona-negociacao/adiciona-negociacao.component';
import { BotaoComponent } from './botao/botao.component';
import { CampoComponent } from './campo/campo.component';
import { AcessoClienteComponent } from './cliente/acesso/acesso-cliente.component';
import { ListaComponent } from './lista/lista.component';
import { NgxCurrencyDirective } from 'ngx-currency';
import { AdicionaProdutoVendedorComponent } from './adiciona-produto-vendedor/adiciona-produto-vendedor.component';
import { CampoDinheiroComponent } from './campo-dinheiro/campo-dinheiro.component';
import { AdicionaLanceComponent } from './adiciona-lance/adiciona-lance.component';
import { CampoCategoriasComponent } from './campo-categorias/campo-categorias.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OpcoesComponent } from './opcoes/opcoes.component';
import { CarrosselImagensComponent } from './carrossel-imagens/carrossel-imagens.component';
import { ConteudoComponent } from './conteudo/conteudo.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ModalCriarMarca } from '../pages/minha-conta/administrativo/modal-criar-marca/modal-criar-marca-component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { StepperComponent } from './stepper/stepper.component';
import { AccordionShoppingComponent } from './accordion-shopping/accordion-shopping.component';
import { PackerComponent } from './packer/packer.component';
import { ReviewOrderModalComponent } from './review-order-modal/review-order-modal.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { AdicionaNegociacaoCompostaComponent } from './adiciona-negociacao-composta/adiciona-negociacao-composta.component';
import { ExpiredNegotiationsComponent } from './expired-negotiations/expired-negotiations.component';
import { AddToListModalComponent } from './add-to-list-modal/add-to-list-modal.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../pages/shared/shared.module';
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatListModule } from "@angular/material/list";
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CarouselModule } from 'primeng/carousel';
import { TabsModule } from 'primeng/tabs'
import { DividerModule } from 'primeng/divider';
import { CardModule } from 'primeng/card';
import { MatTabsModule } from '@angular/material/tabs';
import { GalleriaModule } from 'primeng/galleria';
import { AvatarModule } from 'primeng/avatar';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { ReviewModalComponent } from './review-modal/review-modal.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { SaveAndEditComponent } from '../pages/minha-conta/garage/modals/save-and-edit/save-and-edit.component';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber'; // Para p-inputNumber
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AccordionModule } from 'primeng/accordion';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ConfirmComponent } from '../pages/minha-conta/garage/modals/confirm/confirm.component';
import { TooltipModule } from 'primeng/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProdutoCandidatoSelectorComponent } from './produto-candidato-selector/produto-candidato-selector.component';
import { TornarRecorrenteModalComponent } from './tornar-recorrente-modal/tornar-recorrente-modal.component';
import { TornarRecorrenteFormComponent } from './tornar-recorrente-form/tornar-recorrente-form.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatRadioModule,
    NgxCurrencyDirective,
    NgxMaskModule.forRoot(),
    NgxSkeletonLoaderModule,
    MatSnackBarModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    SharedModule,
    ZXingScannerModule,
    RouterModule,
    MatCardModule,
    MatChipsModule,
    MatTooltipModule,
    MatListModule,
    DialogModule,
    DropdownModule,
    IconFieldModule,
    InputIconModule,
    InputNumberModule,
    TooltipModule,
    CheckboxModule,
    SelectModule,
    DatePickerModule,
    RadioButtonModule,
    AccordionModule,
    SelectButtonModule,
    ButtonModule,
    CarouselModule,
    TabsModule,
    DividerModule,
    CardModule,
    MatTabsModule,
    GalleriaModule,
    AvatarModule,
    FileUpload,
    ToastModule,
    MatProgressSpinnerModule,
  ],
  declarations: [
    ReviewModalComponent,
    RatingComponent,
    SpinnerComponent,
    RegistroClienteComponent,
    EditarDadosClienteComponent,
    AdicionaNegociacaoComponent,
    BotaoComponent,
    CampoComponent,
    AcessoClienteComponent,
    ListaComponent,
    AdicionaProdutoVendedorComponent,
    CampoDinheiroComponent,
    AdicionaLanceComponent,
    CampoCategoriasComponent,
    OpcoesComponent,
    CarrosselImagensComponent,
    ConteudoComponent,
    ModalCriarMarca,
    StepperComponent,
    AccordionShoppingComponent,
    PackerComponent,
    ConfirmComponent,
    SaveAndEditComponent,
    ProductCardComponent,
    ReviewOrderModalComponent,
    AdicionaNegociacaoCompostaComponent,
    ExpiredNegotiationsComponent,
    AddToListModalComponent,
    ProdutoCandidatoSelectorComponent,
    TornarRecorrenteModalComponent,
    TornarRecorrenteFormComponent,
  ],
  exports: [
    MatListModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    PackerComponent,
    ConfirmComponent,
    SaveAndEditComponent,
    ProductCardComponent,
    AccordionShoppingComponent,
    ExpiredNegotiationsComponent,
    StepperComponent,
    BotaoComponent,
    CampoComponent,
    CampoDinheiroComponent,
    ListaComponent,
    RatingComponent,
    SpinnerComponent,
    AdicionaNegociacaoComponent,
    AdicionaProdutoVendedorComponent,
    RegistroClienteComponent,
    EditarDadosClienteComponent,
    AcessoClienteComponent,
    AdicionaLanceComponent,
    CampoCategoriasComponent,
    CarrosselImagensComponent,
    OpcoesComponent,
    ConteudoComponent,
    ModalCriarMarca,
    ReviewOrderModalComponent,
    AdicionaNegociacaoCompostaComponent,
    AddToListModalComponent,
    ProdutoCandidatoSelectorComponent,
    TornarRecorrenteModalComponent,
    TornarRecorrenteFormComponent,
    MatProgressSpinnerModule,
    DialogModule,
    ButtonModule,
    CarouselModule,
    TabsModule,
    DividerModule,
    CardModule,
    MatTabsModule,
    GalleriaModule,
    AvatarModule,
    FileUpload,
    ToastModule,
    ReviewModalComponent,
  ]
})
export class CoreModule {

  constructor() { }
}
